var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMarkStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.5,
    fill: "#D8DDE1",
    stroke: "#6A7988",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.672 10.489L7.683 10.258C7.881 8.19 9.641 8.212 9.641 7.035C9.641 6.474 9.234 6.067 8.574 6.067C7.716 6.067 7.265 6.727 6.957 7.431L6 6.936C6.517 5.869 7.287 5 8.64 5C9.949 5 10.873 5.825 10.873 6.98C10.873 8.751 8.772 8.762 8.684 10.489H7.672ZM7.518 12.777V11.413H8.86V12.777H7.518Z",
    fill: "#6A7988"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkStatus);
export default __webpack_public_path__ + "static/media/question-mark-status.9fe1465845c6a6d0d530a9c070994144.svg";
export { ForwardRef as ReactComponent };